import styled, { css } from 'styled-components';

export const Header = styled.header`
  align-items: center;
  justify-content: space-between;

  padding: 5.2rem 6rem 0 6rem;

  > button {
    max-width: none;
    margin-bottom: 1rem;
  }

  @media (max-width: 768px) {
    padding: 2rem;
  }
`;

export const ContentRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  width: 100%;
  height: 5rem;

  @media (min-width: 475px) {
    display: flex;
  }
`;

export const InputContainer = styled.div`
  background: #fff;

  width: 100%;

  height: 5rem;
  border-radius: 8rem;

  @media (min-width: 475px) {
    display: flex;
  }

  @media (min-width: 768px) {
    max-width: 42rem;
  }

  form {
    background: #fff;
    width: 100%;
    height: 5rem;
    border-radius: 8rem;
    flex: 1;

    display: flex;
    align-items: center;
    height: 100%;

    svg {
      &:first-child {
        margin-left: 2.5rem;
        margin-right: 0.8rem;
      }

      &:last-child {
        width: 4rem;
        height: auto;

        margin-right: 3rem;
        cursor: pointer;

        border-radius: 50%;

        transition: 180ms ease-in;

        :hover {
          background: #d3d3d3;
        }
      }
    }

    input {
      width: 100%;
      height: 100%;
      border: 0;

      font-size: 1.7rem;
      letter-spacing: 0.85px;
      line-height: 2.1rem;
      color: #000;

      &::placeholder {
        color: #000000;
      }
    }
  }
`;

export const ButtonExportReport = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(155deg, #ffdf22 0%, #ffd503 100%);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;

  margin-left: 1rem;

  position: relative;

  > svg {
    width: 2.8rem;
    height: 2.8rem;

    border-radius: 50%;
    .a {
      fill: #000000;
    }
  }

  > div {
    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    top: 5rem;
    right: 0;

    width: 18.7rem;
    height: 3.3rem;

    background: #ffffff;
    box-shadow: 0px 3px 6px #10101087;
    border-radius: 0.3rem;
    opacity: 0;
    transition: 300ms ease-in;
    margin-top: 0.5rem;

    pointer-events: visible;

    > p {
      font-size: 1.7rem;
      letter-spacing: 0.85px;
      line-height: 2.1rem;
      color: #000;
    }
  }

  &:hover {
    background: linear-gradient(155deg, #ffdf22d1 0%, #ffd503d1 100%);

    > div {
      opacity: 1;
      pointer-events: visible;
    }
  }
`;

export const ModalFilterContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 48.7rem;
  height: 100%;
`;

export const ModalTitle = styled.h1`
  font-size: 3.4rem;
  letter-spacing: 0.17rem;
  line-height: 2.9rem;
  text-transform: uppercase;
  color: #000000;

  text-align: center;
  margin-bottom: 4.1rem;

  display: flex;
  align-items: center;
  justify-items: center;
  gap: 1rem;

  svg {
    cursor: pointer;
  }
`;

export const ModalLineContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  margin-bottom: 3.5rem;
  width: 100%;
`;

export const CheckBox = styled.input.attrs({ type: 'checkBox' })`
  width: 2.7rem;
  height: 2.7rem;
`;

type FieldSetProps = {
  container?: boolean;
};

export const FieldSet = styled.fieldset<FieldSetProps>`
  border: none;
  display: flex;
  flex-direction: column;

  ${(props) =>
    props.container &&
    css`
      max-height: 14rem;
      flex-wrap: wrap;
    `}
`;

export const FieldContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const FieldSetLabel = styled.label`
  font-weight: bold;
  font-size: 1.8rem;
  margin-bottom: 1.3rem;
`;

export const ModalButton = styled.button.attrs({ type: 'button' })`
  width: 48.7rem;
  height: 5.8rem;
  background: transparent
    linear-gradient(96deg, var(--unnamed-color-000000) 0%, #232323 100%) 0% 0%
    no-repeat padding-box;
  background: transparent linear-gradient(96deg, #000000 0%, #232323 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 5rem;
  opacity: 1;

  color: #fff;
  font-weight: bold;
  font-size: 2.4rem;

  @media (max-width: 425px) {
    width: 70%;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background: #0f0f0f;

  display: flex;
  flex-direction: column;

  overflow: auto;
`;

export const CardContainer = styled.ul`
  margin: 0 3.1rem;
  margin-top: 4rem;

  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 3rem 2rem;

  @media (max-width: 1440px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

export const CheckboxSet = styled.fieldset`
  border: none;
  padding-left: 0.5rem;

  display: flex;
  flex-direction: column;
  margin-bottom: 0.7rem;
`;

type CheckButtonProps = {
  isSelected?: boolean;
};

export const CheckButton = styled.button.attrs({
  type: 'button',
})<CheckButtonProps>`
  margin-bottom: 0.5rem;
  background: transparent;

  display: flex;

  align-items: center;

  .radio {
    width: 2.2rem;
    height: 2.2rem;
    background: #fff;

    border: 1px solid #000;
    border-radius: 0.4rem;
  }

  .filled {
    width: 100%;
    height: 100%;
    border: 1px solid #fff;
    border-radius: 0.4rem;

    background: ${({ isSelected }) => (isSelected ? '#000' : false)};
  }

  p {
    color: #000;

    font-size: 1.8rem;
    padding: 0 0.5rem;
    text-transform: capitalize;
  }

  :active {
    filter: opacity(0.8);
  }
`;

export const AdvancedSettingsButton = styled.button.attrs({ type: 'button' })`
  background: transparent;
  display: flex;
  align-items: center;

  font-size: 1.8rem;
  font-weight: bold;

  margin-bottom: 0.5rem;
`;

type AdvancedSettingsContainerProps = {
  isActive?: boolean;
};

export const AdvancedSettingsContainer = styled.div<AdvancedSettingsContainerProps>`
  ${({ isActive }) => css`
    display: ${isActive ? 'block' : 'none'};
  `}

  width: 100%;
  height: 20rem;
  border: 1px solid #70707029;
  border-radius: 0.8rem;

  padding: 1rem 2.4rem;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 9px;
  }

  ::-webkit-scrollbar-track {
    background: #e9e9e9;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #000;
    border-radius: 20px;
    border: 2px solid #e9e9e9;
  }
`;

export const AdvancedSettingsSet = styled.fieldset`
  display: flex;
  flex-direction: column;
  width: 100%;

  border: none;
`;

export const ProfileCodeLabel = styled.span`
  display: flex;
  justify-content: center;
  text-align: center;

  font-size: 1.8rem;
  font-weight: bold;
`;

export const Divider = styled.div`
  width: 100%;
  height: 0.1rem;

  border: 1px solid #00000050;
  margin: 1rem 0;
`;

export const AlertContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;

  flex: 1;

  > h1 {
    color: #ffdf22;
  }
`;

export const NoDataFound = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  flex: 1;

  > h1 {
    color: #ffdf22;
  }
`;

export const PaginateContainer = styled.div`
  margin: 0 3.1rem;
  padding: 0 2rem;

  @media (max-width: 425px) {
    margin: 0 1.1rem;
  }

  @media (min-width: 768px) {
    padding: 0;
  }

  /* Pagination */
  .pagination {
    display: flex;
    justify-content: flex-end;
    list-style: none;
    outline: none;

    margin: 3.5rem 0;
  }

  .pagination > li > a {
    border: 1px solid #dcdcdc;
    padding: 1.2rem 1.5rem;
    outline: none;
    cursor: pointer;

    font-size: 1.3rem;
    color: #ffffff;

    &:hover {
      background: #ffffff;
      color: #0f0f0f;
    }
  }

  .pagination > .active > a,
  .pagination > .active > span,
  .pagination > .active > a:hover,
  .pagination > .active > span:hover,
  .pagination > .active > a:focus,
  .pagination > .active > span:focus {
    background-color: #ffffff;
    border: 1px solid #959595;
    color: #0f0f0f;
    font-weight: bold;
  }
  .pagination > li > a,
  .pagination > li > span {
    color: #9e9e9e;
  }
  .pagination > li:first-child > a,
  .pagination > li:first-child > span,
  .pagination > li:last-child > a,
  .pagination > li:last-child > span {
    border-radius: unset;
  }

  .previous,
  .break,
  .break-me {
    display: none;
  }

  .pagination > li:nth-child(2) > a {
    border-top-left-radius: 0.4rem;
    border-bottom-left-radius: 0.4rem;
  }

  .pagination > li:last-child > a {
    border-top-right-radius: 0.4rem;
    border-bottom-right-radius: 0.4rem;
  }
`;
